import oRequest from '@/libsV2/request.js';
import {Toast} from "mint-ui";
import {requestAesPost5} from "@/libsV2/requestAes";
// import store from "@/store/store";

const URL = {
    WECHAT_QROAUTH: "wechat/xcx/qroauth", // 企业微信授权地址
    SEARCH_CONFIG: 'project/index/getconf',
    SEARCH_CONFIG_AES: 'project/v3/indexaes/getconf ',
    CASE_LISTS: 'project/v3/index/lists', //当前城市的案例
    CASE_LISTS_AES: 'project/v3/indexaes/lists', //当前城市的案例
    ALL_CASE_LISTS: 'project/v3/index/others', //周边城市(全国)的案例
    ALL_CASE_LISTS_AES: 'project/v3/indexaes/others', //周边城市(全国)的案例
    MAP_DATA: 'project/v3/index/total',//地图数据
    MAP_DATA_AES: 'project/v3/indexaes/total',//地图数据
    // MAP_PLOTS: 'project/v3/index/plots',//地图小区坐标点
    MAP_PLOTS: 'project/v3/index/plotsv2',//地图小区坐标点
    MAP_PLOTS_AES: 'project/v3/indexaes/plotsv2',//地图小区坐标点
    // MAP_LIST: 'project/v3/index/projectByplots', //地图案例
    MAP_LIST: 'project/v3/index/projectByplotsv2', //地图案例
    MAP_LIST_AES: 'project/v3/indexaes/projectByplotsv2', //地图案例
    CASE_INFO: 'project/v3/index/info', //案例详情
    CASE_INFO_AES: 'project/v3/indexaes/info', //案例详情
    CASE_DISCUSS: 'project.discuss/info', //案例评论
    CASE_DISCUSS_AES: 'project/v3/discussaes/info', //案例评论
    CASE_DISCUSS_LIST: 'project.discuss/lists', //案例评论列表
    CASE_DISCUSS_LIST_AES: 'project/v3/discussaes/lists', //案例评论列表
    POSTER_INFO: 'project/discuss/poster', //案例评论海报信息
    POSTER_INFO_AES: 'project/v3/discussaes/poster', //案例评论海报信息
    // WORD_INFO: 'member/process/infov2', //施工详情(交付书数据)
    WORD_INFO: 'project/v3/index/process', //施工详情(交付书数据)
    WORD_INFO_AES: 'project/v3/indexaes/process', //施工详情(交付书数据)
    WORD_INFO2: 'project/v3/index/item', //施工详情(后台数据)
    WORD_INFO2_AES: 'project/v3/indexaes/item', //施工详情(后台数据)
    CHECK_ZXY: 'project/discuss/checkNoticeAuth',// 是不是直销员
    CHECK_ZXY_AES: 'project/v3/discussaes/checkNoticeAuth',// 是不是直销员
    TIPS_NUM: 'project/discuss/notice_num', // 获取通知的数量
    TIPS_NUM_AES: 'project/v3/discussaes/notice_num', // 获取通知的数量
    TIPS_LIST: 'project/discuss/notice_lists', // 获取通知列表
    TIPS_LIST_AES: 'project/v3/discussaes/notice_lists', // 获取通知的数量
    CASE_PREVIREW: 'project/v3/draft/info',//案例详情( 交付书数据)预览
    CASE_PREVIREW2: 'project/v3/index/delivery', //案例详情(后台数据)预览
    WORD_PREVIREW: 'project/v3/draft/item',//施工详情(后台数据)预览
    DISCUSS_PREVIREW: 'project/v3/draft/getDiscussDraft', //评论预览
    SHARE_NUM: 'project/discuss/addShareNum', //口碑分享统计
    READ_NUM: 'project/discuss/addReadNum', //口碑阅读统计
    GET_POSTER_DRAFT: 'project/v3/draft/getPosterDraft',//获取预览海报
    ENTERPRISE: 'project/v3/index/enterprise', // 分享记录保存请求url
    COLLECT: 'project/v3/index/collect', // 收藏
    COLLECT_AES: 'project/v3/indexaes/collect', // 收藏
    GET_QRCODE: 'comm/qrcode/get',//获取小程序二维码
    //案例详情接口拆分
    CASE_INFO_V2: 'project/v3/info/info', // 案例详情
    IS_COMPLETE: 'project/v3/info/complete', // 是否完工， 判断施工档案调交付书数据还是后台数据
    WORD_DELIVERY: 'project/v3/info/delivery', //施工档案-交付书数据
    WORD_ITEM: 'project/v3/info/item', //施工档案-交付书数据
    SERVICE_ITEM: 'project/v3/info/service', //服务团队
    SELLER_INFO: 'project/v3/info/seller', //直销员信息

    GETTREE: "https://asset.ali-cache.com/2022/0513/aosmith/core/api/js/district_1.0.1.json",//省市区联动JSON
}

export const getWechatQroauth = (data = {}) => {
    return new Promise((resolve, recject) => {
        oRequest.getData(URL.WECHAT_QROAUTH, data).then(res => {
            if (res.data.error == 0) {
                resolve(res);
            } else {
                Toast({
                    message: res.data.msg,
                    duration: 1200
                });
                recject()
            }
        })
    })
};

export const getSearchConfig = (data = {}) => {
    return new Promise((resolve, recject) => {
        oRequest.getData(URL.SEARCH_CONFIG, data).then(res => {
            if (res.data.error == 0) {
                resolve(res);
            } else {
                Toast({
                    message: res.data.msg,
                    duration: 1200
                });
                recject()
            }
        })
    })
}

export const getCaseList = (data = {}) => {
    return new Promise((resolve, recject) => {
        oRequest.getData(URL.CASE_LISTS, data).then(res => {
            if (res.data.error == 0) {
                resolve(res);
            } else {
                Toast({
                    message: res.data.msg,
                    duration: 1200
                });
                recject()
            }
        })
    })
}

export const getAllCaseList = (data = {}) => {
    return new Promise((resolve, recject) => {
        oRequest.getData(URL.ALL_CASE_LISTS, data).then(res => {
            if (res.data.error == 0) {
                resolve(res);
            } else {
                Toast({
                    message: res.data.msg,
                    duration: 1200
                });
                recject()
            }
        })
    })
}

export const getMapData = (data = {}) => {
    return new Promise((resolve, recject) => {
        oRequest.getData(URL.MAP_DATA, data).then(res => {
            if (res.data.error == 0) {
                resolve(res);
            } else {
                Toast({
                    message: res.data.msg,
                    duration: 1200
                });
                recject()
            }
        })
    })
}

export const getMapPlots = (data = {}) => {
    return new Promise((resolve, recject) => {
        oRequest.getData(URL.MAP_PLOTS, data).then(res => {
            if (res.data.error == 0) {
                resolve(res);
            } else {
                Toast({
                    message: res.data.msg,
                    duration: 1200
                });
                recject()
            }
        })
    })
}

export const getMapList = (data = {}) => {
    return new Promise((resolve, recject) => {
        oRequest.getData(URL.MAP_LIST, data).then(res => {
            if (res.data.error == 0) {
                resolve(res);
            } else {
                Toast({
                    message: res.data.msg,
                    duration: 1200
                });
                recject()
            }
        })
    })
}

export const getCaseInfo = (data = {}) => {
    return new Promise((resolve, recject) => {
        oRequest.getData(URL.CASE_INFO, data).then(res => {
            if (res.data.error == 0) {
                resolve(res);
            } else {
                Toast({
                    message: res.data.msg,
                    duration: 1200
                });
                recject()
            }
        })
    })
}

export const getCaseDiscuss = (data = {}) => {
    return new Promise((resolve, recject) => {
        oRequest.getData(URL.CASE_DISCUSS, data).then(res => {
            if (res.data.error == 0) {
                resolve(res);
            } else {
                Toast({
                    message: res.data.msg,
                    duration: 1200
                });
                recject()
            }
        })
    })
}

export const getCaseDiscussList = (data = {}) => {
    return new Promise((resolve, recject) => {
        oRequest.getData(URL.CASE_DISCUSS_LIST, data).then(res => {
            if (res.data.error == 0) {
                resolve(res);
            } else {
                Toast({
                    message: res.data.msg,
                    duration: 1200
                });
                recject()
            }
        })
    })
}

export const getPosterInfo = (data = {}) => {
    return new Promise((resolve, recject) => {
        oRequest.getData(URL.POSTER_INFO, data).then(res => {
            if (res.data.error == 0) {
                resolve(res);
            } else {
                Toast({
                    message: res.data.msg,
                    duration: 1200
                });
                recject()
            }
        })
    })
}

export const getWordInfo = (data = {}) => {
    return new Promise((resolve, recject) => {
        oRequest.getData(URL.WORD_INFO, data).then(res => {
            if (res.data.error == 0) {
                resolve(res);
            } else {
                Toast({
                    message: res.data.msg,
                    duration: 1200
                });
                recject()
            }
        })
    })
}

export const getWordInfo2 = (data = {}) => {
    return new Promise((resolve, recject) => {
        oRequest.getData(URL.WORD_INFO2, data).then(res => {
            if (res.data.error == 0) {
                resolve(res);
            } else {
                Toast({
                    message: res.data.msg,
                    duration: 1200
                });
                recject()
            }
        })
    })
}

export const checkZxy = (data = {}) => {
    return new Promise((resolve, recject) => {
        oRequest.getData(URL.CHECK_ZXY, data).then(res => {
            if (res.data.error == 0) {
                resolve(res);
            } else {
                Toast({
                    message: res.data.msg,
                    duration: 1200
                });
                recject()
            }
        })
    })
}

export const getTipsNum = (data = {}) => {
    return new Promise((resolve, recject) => {
        oRequest.getData(URL.TIPS_NUM, data).then(res => {
            if (res.data.error == 0) {
                resolve(res);
            } else {
                Toast({
                    message: res.data.msg,
                    duration: 1200
                });
                recject()
            }
        })
    })
}

export const getCasePrevirew = (data = {}) => {
    return new Promise((resolve, recject) => {
        oRequest.singleAjaxData(URL.CASE_PREVIREW, data).then(res => {
            if (res.data.error == 0) {
                resolve(res);
            } else {
                Toast({
                    message: res.data.msg,
                    duration: 1200
                });
                recject()
            }
        })
    })
}

export const getCasePrevirew2 = (data = {}) => {
    return new Promise((resolve, recject) => {
        oRequest.singleAjaxData(URL.CASE_PREVIREW2, data).then(res => {
            if (res.data.error == 0) {
                resolve(res);
            } else {
                Toast({
                    message: res.data.msg,
                    duration: 1200
                });
                recject()
            }
        })
    })
}

export const getWordPrevirew = (data = {}) => {
    return new Promise((resolve, recject) => {
        oRequest.singleAjaxData(URL.WORD_PREVIREW, data).then(res => {
            if (res.data.error == 0) {
                resolve(res);
            } else {
                Toast({
                    message: res.data.msg,
                    duration: 1200
                });
                recject()
            }
        })
    })
}


export const getDiscussPrevirew = (data = {}) => {
    return new Promise((resolve, recject) => {
        oRequest.singleAjaxData(URL.DISCUSS_PREVIREW, data).then(res => {
            if (res.data.error == 0) {
                resolve(res);
            } else {
                Toast({
                    message: res.data.msg,
                    duration: 1200
                });
                recject()
            }
        })
    })
}


export const shareNum = (data, type) => {
    return new Promise((resolve, recject) => {
        oRequest.getData(URL.SHARE_NUM, data).then(res => {
            if (res.data.error == 0) {
                resolve(res);
            } else {
                Toast({
                    message: res.data.msg,
                    duration: 1200
                });
                recject()
            }
        })
    })
}

export const readNum = (data, type) => {
    return new Promise((resolve, recject) => {
        oRequest.getData(URL.READ_NUM, data).then(res => {
            if (res.data.error == 0) {
                resolve(res);
            } else {
                Toast({
                    message: res.data.msg,
                    duration: 1200
                });
                recject()
            }
        })
    })
}
export const addEnterPrise = (data, type) => {
    return new Promise((resolve, recject) => {
        oRequest.getData(URL.ENTERPRISE, data).then(res => {
            if (res.data.error == 0) {
                resolve(res);
            } else {
                Toast({
                    message: res.data.msg,
                    duration: 1200
                });
                recject()
            }
        })
    })
}
export const getPosterDraft = (data, type) => {
    return new Promise((resolve, recject) => {
        oRequest.singleAjaxData(URL.GET_POSTER_DRAFT, data).then(res => {
            if (res.data.error == 0) {
                resolve(res);
            } else {
                Toast({
                    message: res.data.msg,
                    duration: 1200
                });
                recject()
            }
        })
    })
}

export const getCaseInfoV2 = (data, type) => {
    return new Promise((resolve, recject) => {
        oRequest.singleAjaxData(URL.CASE_INFO_V2, data).then(res => {
            if (res.data.error == 0) {
                resolve(res);
            } else {
                Toast({
                    message: res.data.msg,
                    duration: 1200
                });
                recject()
            }
        })
    })
}

export const isComplete = (data, type) => {
    return new Promise((resolve, recject) => {
        oRequest.singleAjaxData(URL.IS_COMPLETE, data).then(res => {
            if (res.data.error == 0) {
                resolve(res);
            } else {
                Toast({
                    message: res.data.msg,
                    duration: 1200
                });
                recject()
            }
        })
    })
}
export const getWordDelivery = (data, type) => {
    return new Promise((resolve, recject) => {
        oRequest.singleAjaxData(URL.WORD_DELIVERY, data).then(res => {
            if (res.data.error == 0) {
                resolve(res);
            } else {
                Toast({
                    message: res.data.msg,
                    duration: 1200
                });
                recject()
            }
        })
    })
}

export const getWordItem = (data, type) => {
    return new Promise((resolve, recject) => {
        oRequest.singleAjaxData(URL.WORD_ITEM, data).then(res => {
            if (res.data.error == 0) {
                resolve(res);
            } else {
                Toast({
                    message: res.data.msg,
                    duration: 1200
                });
                recject()
            }
        })
    })
}

export const getServiceItem = (data, type) => {
    return new Promise((resolve, recject) => {
        oRequest.singleAjaxData(URL.SERVICE_ITEM, data).then(res => {
            if (res.data.error == 0) {
                resolve(res);
            } else {
                Toast({
                    message: res.data.msg,
                    duration: 1200
                });
                recject()
            }
        })
    })
}

export const getSellerInfo = (data, type) => {
    return new Promise((resolve, recject) => {
        oRequest.singleAjaxData(URL.SELLER_INFO, data).then(res => {
            if (res.data.error == 0) {
                resolve(res);
            } else {
                Toast({
                    message: res.data.msg,
                    duration: 1200
                });
                recject()
            }
        })
    })
}

export const getTree = () => {
    return new Promise((resolve, recject) => {
        oRequest.getDataJson(URL.GETTREE).then(res => {
            resolve(res);
        }).catch((err) => {
            recject(err)
        })
    })
}

//交互中心-获取案例信息，不调用init,验证uesr_id
// h5大屏，不调用init,不验证uesr_id

export const getPlanSearchConfig = (data = {}) => {
    return new Promise((resolve, recject) => {
        oRequest.singleAjaxData(URL.SEARCH_CONFIG_AES, data, false).then(res => {
            if (res.data.error == 0) {
                resolve(res);
            } else {
                Toast({
                    message: res.data.msg,
                    duration: 1200
                });
                recject()
            }
        })
    })
}

export const getPlanCaseList = (data = {}) => {
    return new Promise((resolve, recject) => {
        oRequest.singleAjaxData(URL.CASE_LISTS_AES, data, false).then(res => {
            if (res.data.error == 0) {
                resolve(res);
            } else {
                Toast({
                    message: res.data.msg,
                    duration: 1200
                });
                recject()
            }
        })
    })
}

export const getPlanAllCaseList = (data = {}) => {
    return new Promise((resolve, recject) => {
        oRequest.singleAjaxData(URL.ALL_CASE_LISTS_AES, data, false).then(res => {
            if (res.data.error == 0) {
                resolve(res);
            } else {
                Toast({
                    message: res.data.msg,
                    duration: 1200
                });
                recject()
            }
        })
    })
}

export const getPlanMapData = (data = {}) => {
    return new Promise((resolve, recject) => {
        oRequest.singleAjaxData(URL.MAP_DATA_AES, data, false).then(res => {
            if (res.data.error == 0) {
                resolve(res);
            } else {
                Toast({
                    message: res.data.msg,
                    duration: 1200
                });
                recject()
            }
        })
    })
}

export const getPlanMapPlots = (data = {}) => {
    return new Promise((resolve, recject) => {
        oRequest.singleAjaxData(URL.MAP_PLOTS_AES, data, false).then(res => {
            if (res.data.error == 0) {
                resolve(res);
            } else {
                Toast({
                    message: res.data.msg,
                    duration: 1200
                });
                recject()
            }
        })
    })
}

export const getPlanMapList = (data = {}) => {
    return new Promise((resolve, recject) => {
        oRequest.singleAjaxData(URL.MAP_LIST_AES, data, false).then(res => {
            if (res.data.error == 0) {
                resolve(res);
            } else {
                Toast({
                    message: res.data.msg,
                    duration: 1200
                });
                recject()
            }
        })
    })
}


export const getPlanCaseInfo = (data = {}) => {
    return new Promise((resolve, recject) => {
        oRequest.singleAjaxData(URL.CASE_INFO_AES, data, false).then(res => {
            if (res.data.error == 0) {
                resolve(res);
            } else {
                Toast({
                    message: res.data.msg,
                    duration: 1200
                });
                recject()
            }
        })
    })
}

export const getPlanCaseDiscuss = (data = {}) => {
    return new Promise((resolve, recject) => {
        oRequest.singleAjaxData(URL.CASE_DISCUSS_AES, data, false).then(res => {
            if (res.data.error == 0) {
                resolve(res);
            } else {
                Toast({
                    message: res.data.msg,
                    duration: 1200
                });
                recject()
            }
        })
    })
}

export const getPlanCaseDiscussList = (data = {}) => {
    return new Promise((resolve, recject) => {
        oRequest.singleAjaxData(URL.CASE_DISCUSS_LIST_AES, data, false).then(res => {
            if (res.data.error == 0) {
                resolve(res);
            } else {
                Toast({
                    message: res.data.msg,
                    duration: 1200
                });
                recject()
            }
        })
    })
}

export const checkPlanZxy = (data = {}) => {
    return new Promise((resolve, recject) => {
        oRequest.singleAjaxData(URL.CHECK_ZXY_AES, data, false).then(res => {
            if (res.data.error == 0) {
                resolve(res);
            } else {
                Toast({
                    message: res.data.msg,
                    duration: 1200
                });
                recject()
            }
        })
    })
}

export const getPlanTipsNum = (data = {}) => {
    return new Promise((resolve, recject) => {
        oRequest.singleAjaxData(URL.TIPS_NUM_AES, data, false).then(res => {
            if (res.data.error == 0) {
                resolve(res);
            } else {
                Toast({
                    message: res.data.msg,
                    duration: 1200
                });
                recject()
            }
        })
    })
}

export const getPlanTipsList = (data = {}) => {
    return new Promise((resolve, recject) => {
        oRequest.singleAjaxData(URL.TIPS_LIST_AES, data, false).then(res => {
            if (res.data.error == 0) {
                resolve(res.data.data);
            } else {
                Toast({
                    message: res.data.msg,
                    duration: 1200
                });
                recject()
            }
        })
    })
}


export const getPlanWordInfo = (data = {}) => {
    return new Promise((resolve, recject) => {
        oRequest.singleAjaxData(URL.WORD_INFO_AES, data, false).then(res => {
            if (res.data.error == 0) {
                resolve(res);
            } else {
                Toast({
                    message: res.data.msg,
                    duration: 1200
                });
                recject()
            }
        })
    })
}

export const getPlanWordInfo2 = (data = {}) => {
    return new Promise((resolve, recject) => {
        oRequest.singleAjaxData(URL.WORD_INFO2_AES, data, false).then(res => {
            if (res.data.error == 0) {
                resolve(res);
            } else {
                Toast({
                    message: res.data.msg,
                    duration: 1200
                });
                recject()
            }
        })
    })
}

//收藏案例/取消案例
export function setPlanCollect(data = {}) {
    return new Promise((resolve, recject) => {
        oRequest.singleAjaxData(URL.COLLECT_AES, data, false).then(res => {
            if (res.data.error == 0) {
                resolve(res);
            } else {
                Toast({
                    message: res.data.msg,
                    duration: 1200
                });
                recject()
            }
        })
    })
}

export const getPlanPosterInfo = (data = {}) => {
    return new Promise((resolve, recject) => {
        oRequest.singleAjaxData(URL.POSTER_INFO_AES, data, false).then(res => {
            if (res.data.error == 0) {
                resolve(res);
            } else {
                Toast({
                    message: res.data.msg,
                    duration: 1200
                });
                recject()
            }
        })
    })
}

export const getPlanQrcode = (data = {}) => {
    return new Promise((resolve, recject) => {
        oRequest.singleAjaxData(URL.GET_QRCODE, data).then(res => {
            if (res.data.error == 0) {
                resolve(res);
            } else {
                Toast({
                    message: res.data.msg,
                    duration: 1200
                });
                recject()
            }
        })
    })
}
